var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isShowTop)?_c('van-icon',{staticClass:"top-btn",attrs:{"name":"arrow-up"},on:{"click":_vm.scrollTop}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }